import androidstudio from './../../assets/webp/skills/androidstudio.webp'
import cubit from './../../assets/webp/skills/cubit.webp'
import getx from './../../assets/webp/skills/getx.webp'
import github from './../../assets/webp/skills/github.webp'
import hive from './../../assets/webp/skills/hive.webp'
import vscode from './../../assets/webp/skills/vscode.webp'
import xcode from './../../assets/webp/skills/xcode.webp'

export const assets = {
    androidstudio,
    cubit,
    getx,
    github,
    hive,
    vscode,
    xcode,
}